import React from 'react';

import { Flex, Skeleton } from '@mantine/core';

interface ResourceLoadingSkeletonProps {
  count?: number;
}

export function ResourceLoadingSkeleton({ count = 5 }: ResourceLoadingSkeletonProps) {
  const skeletons = Array.from(Array(count).keys());
  return (
    <Flex direction="column" w="100%">
      {skeletons.map((_, key) => (
        <Skeleton key={key} w="100%" h={35} radius="md" my={5} px={5} />
      ))}
    </Flex>
  );
}
